import { memo } from "react";
import { Navigate, useSearchParams } from "react-router-dom";

import { GLOBAL_SEARCH_DEEP_LINK_PARAMS } from "@/constants/global-search";
import { buildModelsSettingsPath } from "@/pages/settings/utils/build-models-settings-path";

// NOTE: NSAI-6657 — `/models` was the Models page; it is a Profile settings tab
// now. Bookmarks, old notification links and `?model=<uuid>` deep links
// (NSAI-6598) keep working: the model parameter is carried over, everything
// else lands on the tab. Replace rather than push, so Back does not bounce the
// reader into this redirect again.
const ModelsRedirectComponent = (): React.ReactElement => {
  const [searchParams] = useSearchParams();

  return (
    <Navigate
      replace
      to={buildModelsSettingsPath({
        modelUuid: searchParams.get(GLOBAL_SEARCH_DEEP_LINK_PARAMS.MODEL),
      })}
    />
  );
};

export const ModelsRedirect = memo(ModelsRedirectComponent);
